import { FaturaAciklama } from './fatura-aciklama';
import { FaturaGorsel } from './fatura-gorsel';
import { FaturaKalem } from './fatura-kalem';

export class FaturaKaydetRequest {

    id: number;
    faturaNo: string;
    faturaTipId: number;
    cariId: number;
    tarih: Date;
    malHizmetCinsi: string;
    malHizmetMiktar: string;
    faturaSeriNo: string;
    aciklama: string;
    subeId: number;
    faturaKalemler: FaturaKalem[];
    faturaGorseller: FaturaGorsel[];
    faturaAciklama: FaturaAciklama;
    talepId: number;
}
